// import { useDateRange } from '@/context/DateRangeContext';
// import { Button, DatePicker, Layout, Menu, Switch } from 'antd';
// import type { Dayjs } from 'dayjs';
// import dayjs from 'dayjs';
// import React, { useState, useMemo, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { datePresets } from './DateConstants';
// import DateDisplay from './DateDisplay';
// import { extendDayjs } from './dateUtility';
// import { useRegion } from '@/context/CountryContext';

// // Extend dayjs with required plugins
// extendDayjs();

// const { RangePicker } = DatePicker;
// const { Sider } = Layout;

// const DateRangePicker: React.FC = () => {
//   // Use the date range context
//   const { dateRange, setDateRange, compare, setCompare, compareRange } =
//     useDateRange();

//   // Get selected region from context
//   const { selectedRegion } = useRegion();

//   // Get current location
//   const location = useLocation();

//   // Define routes that have Today preset
//   const routesWithTodayPreset = [
//     '/dashboard/growth-tracking',
//     '/dashboard/day-parting',
//   ];

//   // Check if current route is in the special routes
//   const isSpecialRoute = routesWithTodayPreset.includes(location.pathname);

//   // Routes where today should be disabled (allow up to yesterday only)
//   const routesDisableToday = [
//     '/dashboard/insight-360',
//     '/dashboard/snap-suite',
//     '/dashboard/campaign-central',
//   ];
//   const shouldDisableToday = routesDisableToday.includes(location.pathname);

//   // Filter presets based on current route
//   const filteredPresets = useMemo(() => {
//     if (isSpecialRoute) {
//       return datePresets; // Show all presets including "Today"
//     } else {
//       // Filter out "Today" preset for other routes
//       return datePresets.filter((preset) => preset.label !== 'Today');
//     }
//   }, [isSpecialRoute]);

//   // Convert context date ranges to Dayjs for antd DatePicker
//   const selectedRange: [Dayjs, Dayjs] | null =
//     dateRange.from && dateRange.to
//       ? [dayjs(dateRange.from), dayjs(dateRange.to)]
//       : null;

//   const compareRangeDayjs: [Dayjs, Dayjs] | null =
//     compareRange.from && compareRange.to
//       ? [dayjs(compareRange.from), dayjs(compareRange.to)]
//       : null;

//   const [open, setOpen] = useState(false);
//   const [activePreset, setActivePreset] = useState<string | null>(null);
//   const customFormat = (value) => value.format('DD MMM, YYYY');

//   // Precomputed display strings for overlay
//   const selectedDisplay = useMemo(() => {
//     if (!selectedRange) return '';
//     return `${selectedRange[0].format('DD MMM, YYYY')} - ${selectedRange[1].format('DD MMM, YYYY')}`;
//   }, [selectedRange]);
//   const compareDisplay = useMemo(() => {
//     if (!(compare && compareRangeDayjs)) return '';
//     return `${compareRangeDayjs[0].format('DD MMM, YYYY')} - ${compareRangeDayjs[1].format('DD MMM, YYYY')}`;
//   }, [compare, compareRangeDayjs]);

//   // Initial state values (customized for /dashboard/day-parting vs other routes)
//   const initialDateRange =
//     location.pathname === '/dashboard/day-parting'
//       ? {
//           from: dayjs().subtract(30, 'day').toDate(),
//           to: dayjs().toDate(), // Include today
//         } // Last 30 days including today for /dashboard/day-parting
//       : isSpecialRoute
//         ? { from: new Date(), to: new Date() } // Today for other special routes
//         : {
//             from: dayjs().subtract(30, 'day').toDate(),
//             to: dayjs().subtract(1, 'day').toDate(),
//           }; // Last 30 days for other routes

//   // Reset to initial state function
//   const resetToInitialState = () => {
//     setDateRange(initialDateRange);
//     setActivePreset(null);
//   };

//   // Reset when route changes
//   useEffect(() => {
//     if (location.pathname === '/dashboard/day-parting') {
//       setDateRange({
//         from: dayjs().subtract(30, 'day').toDate(),
//         to: dayjs().toDate(), // Include today
//       });
//       setActivePreset('Last 30 Days'); // Assumes preset label is "Last 30 Days"
//     } else {
//       setDateRange(initialDateRange);
//       setActivePreset(null);
//     }
//   }, [location.pathname, setDateRange]);

//   // Handle compare mode logic
//   const handleCompareToggle = (checked: boolean) => {
//     setCompare(checked);
//   };

//   // When user clicks a preset from the sidebar
//   const handlePresetClick = (range: [Dayjs, Dayjs], label: string) => {
//     // Convert Dayjs to Date and update context
//     let toDate = range[1].toDate();
//     if (shouldDisableToday && range[1].isSame(dayjs(), 'day')) {
//       // If today is disabled and the preset includes today, use yesterday
//       toDate = dayjs().subtract(1, 'day').toDate();
//     }
//     setDateRange({
//       from: range[0].toDate(),
//       to: toDate,
//     });
//     setActivePreset(label);
//   };

//   const handleOpenChange = () => {
//     setOpen(true);
//   };

//   // Custom cell renderer for highlighting ranges
//   const cellRender = (
//     current: Dayjs,
//     info: { originNode: React.ReactElement }
//   ): React.ReactElement => {
//     const { originNode } = info;

//     // Check if the current date is in the selected range
//     const isInSelectedRange =
//       selectedRange &&
//       current.isSameOrAfter(selectedRange[0]) &&
//       current.isSameOrBefore(selectedRange[1]);

//     // Check if the current date is in the compare range
//     const isInCompareRange =
//       compare &&
//       compareRangeDayjs &&
//       current.isSameOrAfter(compareRangeDayjs[0]) &&
//       current.isSameOrBefore(compareRangeDayjs[1]);

//     // Check if the current date is the start or end of compare range
//     const isCompareStartOrEnd =
//       compare &&
//       compareRangeDayjs &&
//       (current.isSame(compareRangeDayjs[0], 'day') ||
//         current.isSame(compareRangeDayjs[1], 'day'));

//     // Custom styling for selected and compare ranges
//     if (isInSelectedRange && isInCompareRange) {
//       // Date is in both ranges - light background
//       return React.cloneElement(originNode, {
//         className: `${originNode.props.className} bg-slate-100 text-slate-600`,
//       });
//     } else if (isInSelectedRange) {
//       // Date is in primary range
//       return React.cloneElement(originNode);
//     } else if (isCompareStartOrEnd) {
//       // Start or end of compare range - dark background with white text
//       return React.cloneElement(originNode, {
//         className: `${originNode.props.className} bg-slate-800 text-white`,
//       });
//     } else if (isInCompareRange) {
//       // Date is in compare range - light background
//       return React.cloneElement(originNode, {
//         className: `${originNode.props.className} bg-slate-100 text-slate-600`,
//       });
//     }

//     return originNode;
//   };

//   // Sidebar menu items for date presets (now using filtered presets)
//   const sidebarMenuItems = filteredPresets.map((preset) => ({
//     key: preset.label,
//     icon: preset.icon,
//     label: preset.label,
//     onClick: () => handlePresetClick(preset.value, preset.label),
//     style: { height: '30px' },
//     className: activePreset === preset.label ? 'ant-menu-item-selected' : '',
//   }));

//   // Panel rendering customization
//   const handlePanelRender = (originPanel: React.ReactNode) => {
//     return (
//       <div className="custom-panel">
//         <div className="flex">
//           {/* Sidebar with Presets */}
//           <Sider width={160} theme="light" className="rounded-l-lg">
//             <div className="p-4 font-semibold ">Quick Ranges</div>
//             <Menu
//               theme="light"
//               mode="inline"
//               selectedKeys={activePreset ? [activePreset] : []}
//               items={sidebarMenuItems}
//             />
//           </Sider>

//           {/* Main Calendar Panel */}
//           <div className="flex-1 px-4 py-2">
//             {/* The original calendar panel */}
//             {originPanel}

//             {/* Date Range Display Section */}
//             <div className="mt-4 flex justify-between">
//               {/* Selected Date Range */}
//               <DateDisplay
//                 range={selectedRange}
//                 label="Selected Date Range"
//                 type="primary"
//                 onChange={(dates) => {
//                   if (dates) {
//                     setDateRange({
//                       from: dates[0].toDate(),
//                       to: dates[1].toDate(),
//                     });
//                   }
//                 }}
//               />

//               {/* Compare Range */}
//               {compare && compareRangeDayjs && (
//                 <DateDisplay
//                   range={compareRangeDayjs}
//                   label="Compare Range"
//                   type="compare"
//                   onChange={() => {}} // Disabled in this implementation
//                   disabled={true}
//                 />
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="flex justify-between items-center p-4 border-t border-gray-200">
//           <div className="flex items-center">
//             <Switch
//               checked={compare}
//               onChange={(checked) => handleCompareToggle(checked)}
//               checkedChildren="Compare ON"
//               unCheckedChildren="Compare OFF"
//             />
//           </div>

//           <div>
//             {selectedRegion && (
//               <div className="text-sm text-gray-500">
//                 {selectedRegion.location}
//               </div>
//             )}
//           </div>

//           <div className="flex gap-2 items-center">
//             <Button
//               onClick={resetToInitialState}
//               className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded"
//             >
//               Reset
//             </Button>
//             <Button
//               onClick={() => setOpen(false)}
//               className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded"
//             >
//               Cancel
//             </Button>
//             <Button
//               type="primary"
//               onClick={() => {
//                 setOpen(false);
//               }}
//             >
//               Apply
//             </Button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="relative inline-block">
//       {/* Hide native input text so our overlay doesn't overlap */}
//       <style>{`
//         .custom-compare-picker .ant-picker-input input { color: transparent !important; caret-color: transparent !important; }
//         .custom-compare-picker .ant-picker-input input::placeholder { color: transparent !important; }
//         .custom-compare-picker .ant-picker-separator { color: transparent !important; }
//       `}</style>
//       <RangePicker
//         className="custom-compare-picker"
//         open={open}
//         onOpenChange={handleOpenChange}
//         format={customFormat}
//         value={selectedRange ? [selectedRange[0], selectedRange[1]] : null}
//         //@ts-ignore
//         cellRender={cellRender}
//         disabledDate={(current) => {
//           if (!current) return false;
//           const today = dayjs();
//           if (shouldDisableToday) {
//             return (
//               current.isSame(today, 'day') || current.isAfter(today, 'day')
//             );
//           }
//           return current.isAfter(today, 'day');
//         }}
//         onChange={(val) => {
//           if (val && val[0] && val[1]) {
//             const fromDate = dayjs(val[0]).startOf('day').format('YYYY-MM-DD');
//             const toDateRaw = dayjs(val[1]).endOf('day');
//             const today = dayjs().endOf('day');
//             const isToDateToday = toDateRaw.isSame(today, 'day');

//             const toDate =
//               shouldDisableToday && isToDateToday
//                 ? dayjs().subtract(1, 'day').format('YYYY-MM-DD')
//                 : toDateRaw.format('YYYY-MM-DD');

//             setDateRange({
//               from: new Date(fromDate),
//               to: new Date(toDate),
//             });
//           } else {
//             if (isSpecialRoute) {
//               const today = dayjs().format('YYYY-MM-DD');
//               setDateRange({ from: new Date(today), to: new Date(today) });
//             } else {
//               const from = dayjs().subtract(30, 'day').format('YYYY-MM-DD');
//               const to = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
//               setDateRange({ from: new Date(from), to: new Date(to) });
//             }
//           }
//         }}
//         panelRender={handlePanelRender}
//         style={{ width: 270, height: 44 }}
//       />
//       <div
//         className="pointer-events-none absolute inset-0 flex flex-col justify-center px-3"
//         style={{ paddingRight: 34 }}
//       >
//         <div className="text-[13px] text-slate-700 leading-4 whitespace-nowrap overflow-hidden text-ellipsis">
//           {selectedDisplay}
//         </div>
//         {compare && compareDisplay && (
//           <div className="text-[11px] text-slate-500 leading-4 whitespace-nowrap overflow-hidden text-ellipsis">
//             Compared to: {compareDisplay}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DateRangePicker;

import { useDateRange } from '@/context/DateRangeContext';
import { Button, DatePicker, Layout, Menu, Switch } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import React, { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CalendarOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { DatePreset } from './DateConstants';
import DateDisplay from './DateDisplay';
import { extendDayjs } from './dateUtility';
import { useRegion } from '@/context/CountryContext';
import { getDatePresets, getRouteDefaultRange } from './reporting-date-presets';

// Extend dayjs with required plugins
extendDayjs();

const { RangePicker } = DatePicker;
const { Sider } = Layout;

const DateRangePicker: React.FC = () => {
  const { dateRange, setDateRange, compare, setCompare, compareRange } =
    useDateRange();
  const { selectedRegion } = useRegion();
  const location = useLocation();

  const routesWithTodayPreset = [
    '/dashboard/growth-tracking',
    '/dashboard/day-parting',
  ];
  const isSpecialRoute = routesWithTodayPreset.includes(location.pathname);

  const routesDisableToday = [
    '/dashboard/insight-360',
    '/dashboard/snap-suite',
    '/dashboard/campaign-central',
  ];
  const shouldDisableToday = routesDisableToday.includes(location.pathname);

  const accountTimezone =
    selectedRegion.timezoneStatus === 'ready' ? selectedRegion.timezone : undefined;

  const datePresets = useMemo((): DatePreset[] => {
    if (!accountTimezone) return [];
    const presets = getDatePresets(accountTimezone);
    if (!presets) return [];
    return presets.map((preset) => ({
      label: preset.label,
      value: [dayjs(preset.from), dayjs(preset.to)],
      icon:
        preset.label === 'Today' || preset.label === 'Yesterday' ? (
          <ClockCircleOutlined />
        ) : (
          <CalendarOutlined />
        ),
    }));
  }, [accountTimezone]);

  const filteredPresets = useMemo(() => {
    if (isSpecialRoute) {
      return datePresets;
    }
    return datePresets.filter((preset) => preset.label !== 'Today');
  }, [datePresets, isSpecialRoute]);

  const selectedRange: [Dayjs, Dayjs] | null =
    dateRange.from && dateRange.to
      ? [dayjs(dateRange.from), dayjs(dateRange.to)]
      : null;

  const compareRangeDayjs: [Dayjs, Dayjs] | null =
    compareRange.from && compareRange.to
      ? [dayjs(compareRange.from), dayjs(compareRange.to)]
      : null;

  const [open, setOpen] = useState(false);
  const [activePreset, setActivePreset] = useState<string | null>(null);
  const customFormat = (value) => value.format('DD MMM, YYYY');

  const selectedDisplay = useMemo(() => {
    if (!selectedRange) return '';
    return `${selectedRange[0].format('DD MMM, YYYY')} - ${selectedRange[1].format('DD MMM, YYYY')}`;
  }, [selectedRange]);

  const compareDisplay = useMemo(() => {
    if (!(compare && compareRangeDayjs)) return '';
    return `${compareRangeDayjs[0].format('DD MMM, YYYY')} - ${compareRangeDayjs[1].format('DD MMM, YYYY')}`;
  }, [compare, compareRangeDayjs]);

  const initialDateRange = useMemo(() => {
    if (!accountTimezone) return null;
    if (location.pathname === '/dashboard/day-parting') {
      return getRouteDefaultRange(accountTimezone, 'last30ThroughToday');
    }
    if (isSpecialRoute) {
      return getRouteDefaultRange(accountTimezone, 'today');
    }
    return getRouteDefaultRange(accountTimezone, 'last30EndingYesterday');
  }, [accountTimezone, isSpecialRoute, location.pathname]);

  const resetToInitialState = () => {
    if (!initialDateRange) return;
    setDateRange(initialDateRange);
    setActivePreset(null);
  };

  useEffect(() => {
    if (!initialDateRange) return;
    setDateRange(initialDateRange);
    setActivePreset(location.pathname === '/dashboard/day-parting' ? 'Last 30 Days' : null);
  }, [initialDateRange, location.pathname, setDateRange]);

  const handleCompareToggle = (checked: boolean) => {
    setCompare(checked);
  };

  const handlePresetClick = (range: [Dayjs, Dayjs], label: string) => {
    let toDate = range[1].toDate();
    if (shouldDisableToday && accountTimezone) {
      const today = getRouteDefaultRange(accountTimezone, 'today');
      const yesterday = getDatePresets(accountTimezone)?.find(
        (preset) => preset.label === 'Yesterday',
      );
      if (today && yesterday && range[1].isSame(dayjs(today.to), 'day')) {
        toDate = yesterday.to;
      }
    }
    setDateRange({
      from: range[0].toDate(),
      to: toDate,
    });
    setActivePreset(label);
  };

  const handleOpenChange = () => {
    setOpen(true);
  };

  const cellRender = (
    current: Dayjs,
    info: { originNode: React.ReactElement }
  ): React.ReactElement => {
    const { originNode } = info;
    const isInSelectedRange =
      selectedRange &&
      current.isSameOrAfter(selectedRange[0]) &&
      current.isSameOrBefore(selectedRange[1]);
    const isInCompareRange =
      compare &&
      compareRangeDayjs &&
      current.isSameOrAfter(compareRangeDayjs[0]) &&
      current.isSameOrBefore(compareRangeDayjs[1]);
    const isCompareStartOrEnd =
      compare &&
      compareRangeDayjs &&
      (current.isSame(compareRangeDayjs[0], 'day') ||
        current.isSame(compareRangeDayjs[1], 'day'));

    if (isInSelectedRange && isInCompareRange) {
      return React.cloneElement(originNode, {
        className: `${originNode.props.className} bg-slate-100 text-slate-600`,
      });
    } else if (isInSelectedRange) {
      return React.cloneElement(originNode);
    } else if (isCompareStartOrEnd) {
      return React.cloneElement(originNode, {
        className: `${originNode.props.className} bg-slate-800 text-white`,
      });
    } else if (isInCompareRange) {
      return React.cloneElement(originNode, {
        className: `${originNode.props.className} bg-slate-100 text-slate-600`,
      });
    }
    return originNode;
  };

  const sidebarMenuItems = filteredPresets.map((preset) => ({
    key: preset.label,
    icon: preset.icon,
    label: preset.label,
    onClick: () => handlePresetClick(preset.value, preset.label),
    style: { height: '30px' },
    className: activePreset === preset.label ? 'ant-menu-item-selected' : '',
  }));

  const handlePanelRender = (originPanel: React.ReactNode) => {
    return (
      <div className="custom-panel">
        <div className="flex">
          <Sider width={160} theme="light" className="rounded-l-lg">
            <div className="p-4 font-semibold">Quick Ranges</div>
            <Menu
              theme="light"
              mode="inline"
              selectedKeys={activePreset ? [activePreset] : []}
              items={sidebarMenuItems}
            />
          </Sider>
          <div className="flex-1 px-4 py-2">
            {originPanel}
            <div className="mt-4 flex justify-between">
              <DateDisplay
                range={selectedRange}
                label="Selected Date Range"
                type="primary"
                onChange={(dates) => {
                  if (dates) {
                    setDateRange({
                      from: dates[0].toDate(),
                      to: dates[1].toDate(),
                    });
                  }
                }}
              />
              {compare && compareRangeDayjs && (
                <DateDisplay
                  range={compareRangeDayjs}
                  label="Compare Range"
                  type="compare"
                  onChange={() => {}}
                  disabled={true}
                />
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center p-4 border-t border-gray-200">
          <div className="flex items-center">
            <Switch
              checked={compare}
              onChange={(checked) => handleCompareToggle(checked)}
              checkedChildren="Compare ON"
              unCheckedChildren="Compare OFF"
            />
          </div>
          <div>
            {selectedRegion && (
              <div className="text-sm text-gray-500">
                {selectedRegion.location}
              </div>
            )}
          </div>
          <div className="flex gap-2 items-center">
            <Button
              onClick={resetToInitialState}
              className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded"
            >
              Reset
            </Button>
            <Button
              onClick={() => setOpen(false)}
              className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setOpen(false);
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="relative inline-block">
      <style>{`
        .custom-compare-picker .ant-picker-input input { color: transparent !important; caret-color: transparent !important; }
        .custom-compare-picker .ant-picker-input input::placeholder { color: transparent !important; }
        .custom-compare-picker .ant-picker-separator { color: transparent !important; }
      `}</style>
      <RangePicker
        className="custom-compare-picker"
        open={open}
        onOpenChange={handleOpenChange}
        format={customFormat}
        value={selectedRange ? [selectedRange[0], selectedRange[1]] : null}
        //@ts-ignore
        cellRender={cellRender}
        disabledDate={(current) => {
          if (!current || !accountTimezone) return false;
          const todayRange = getRouteDefaultRange(accountTimezone, 'today');
          if (!todayRange) return false;
          const today = dayjs(todayRange.to);
          if (shouldDisableToday) {
            return (
              current.isSame(today, 'day') || current.isAfter(today, 'day')
            );
          }
          return current.isAfter(today, 'day');
        }}
        onChange={(val) => {
          if (val && val[0] && val[1]) {
            const from = new Date(val[0].year(), val[0].month(), val[0].date());
            let to = new Date(val[1].year(), val[1].month(), val[1].date());
            if (shouldDisableToday && accountTimezone) {
              const today = getRouteDefaultRange(accountTimezone, 'today');
              const yesterday = getDatePresets(accountTimezone)?.find(
                (preset) => preset.label === 'Yesterday',
              );
              if (today && yesterday && dayjs(to).isSame(dayjs(today.to), 'day')) {
                to = yesterday.to;
              }
            }
            setDateRange({ from, to });
          } else if (accountTimezone) {
            const range = isSpecialRoute
              ? getRouteDefaultRange(accountTimezone, 'today')
              : getRouteDefaultRange(accountTimezone, 'last30EndingYesterday');
            if (range) setDateRange(range);
          }
        }}
        panelRender={handlePanelRender}
        style={{ width: 270, height: 44 }}
      />
      {/* Close Button Outside the Component (on the input field) - Visible only when open */}
      {open && (
        <Button
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={() => setOpen(false)}
          style={{
            position: 'absolute',
            bottom: -42,
            right: -42,
            color: '#595959',
            backgroundColor: '#f5f5f5',
            border: 'none',
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: '#0b0707ff',
            borderRadius: '50%',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}
          className="hover:bg-gray-200"
        />
      )}
      <div
        className="pointer-events-none absolute inset-0 flex flex-col justify-center px-3"
        style={{ paddingRight: 60 }} // Increased padding to accommodate the close button
      >
        <div className="text-[13px] text-slate-700 leading-4 whitespace-nowrap overflow-hidden text-ellipsis">
          {selectedDisplay}
        </div>
        {compare && compareDisplay && (
          <div className="text-[11px] text-slate-500 leading-4 whitespace-nowrap overflow-hidden text-ellipsis">
            Compared to: {compareDisplay}
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;
